const ArrowOutIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 16.25V20M19.5 20H15.75M19.5 20L14.25 14.75M8.25 20H4.5M4.5 20V16.25M4.5 20L9.75 14.75M15.75 5H19.5M19.5 5V8.75M19.5 5L14.25 10.25M4.5 8.75V5M4.5 5H8.25M4.5 5L9.75 10.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowOutIcon;
